import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./CategoryPage.scss";
import { getAllCategory } from "../../api/category";
import { getProducts } from "../../api/products";
import { addToCart } from "../../api/cart";
import { addToCartList } from "../../store/reducers/cartReducer";

// ── Inline SVG Icons ───────────────────────────────────────
const I = {
  Menu: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  Search: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </svg>
  ),
  User: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Heart: ({ filled }) => (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  ),
  Cart: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  ),
  Home: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  Grid: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
    </svg>
  ),
  List: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  ChevRight: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  ChevLeft: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  ChevDown: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  ChevUp: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="18 15 12 9 6 15" />
    </svg>
  ),
  Sliders: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" />
      <line x1="9" y1="8" x2="15" y2="8" />
      <line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  ),
  Star: ({ filled = true }) => (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={filled ? 0 : 1.5}
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  ShopCart: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  ),
  Truck: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="3" width="15" height="13" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  ),
  Refresh: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  Shield: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Headphones: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
      <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
    </svg>
  ),
  Tag: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  Sparkle: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3v1m0 16v1M4.22 4.22l.7.7m12.16 12.16.7.7M3 12h1m16 0h1M4.22 19.78l.7-.7M18.36 5.64l.7-.7" />
      <circle cx="12" cy="12" r="4" />
    </svg>
  ),
  Monitor: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  ExternalLink: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  ),
};

// ── Static Data ────────────────────────────────────────────
const NAV_ITEMS = [
  { label: "Home", icon: <I.Home />, active: false },
  { label: "Categories", icon: <I.Grid />, active: true },
  { label: "Electronics", icon: <I.Monitor />, active: false },
  { label: "Fashion", icon: <I.Tag />, active: false },
  { label: "Accessories", icon: <I.Headphones />, active: false },
  { label: "Deals", icon: <I.Tag />, active: false },
  { label: "New Arrivals", icon: <I.Sparkle />, active: false },
  { label: "Best Sellers", icon: <I.Star />, active: false },
  { label: "Support", icon: <I.Headphones />, active: false },
];

const TABS = [
  "All",
  "Best Sellers",
  "New Arrivals",
  "Deals",
  "Top Rated",
  "Free Shipping",
];

const RATINGS = [
  { stars: 5, count: 320 },
  { stars: 4, count: 450 },
  { stars: 3, count: 250 },
  { stars: 2, count: 120 },
];

const SUBCATS = [
  {
    key: "smartphones",
    label: "Smartphones",
    items: 340,
    cls: "smartphones",
    img: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=160&q=80",
  },
  {
    key: "laptops",
    label: "Laptops",
    items: 220,
    cls: "laptops",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=160&q=80",
  },
  {
    key: "accessories",
    label: "Accessories",
    items: 285,
    cls: "accessories",
    img: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=160&q=80",
  },
];

const FALLBACK_PRODUCTS = [
  {
    id: 1,
    name: "Apple iPhone 14 Pro Max 256GB Deep Purple",
    price: 999,
    rating: 4.8,
    reviews: 320,
    img: "https://images.unsplash.com/photo-1678685888221-cda773a3dcdb?w=220&q=80",
  },
  {
    id: 2,
    name: "Sony WH-1000XM5 Wireless Headphones",
    price: 349,
    rating: 4.7,
    reviews: 180,
    img: "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=220&q=80",
  },
  {
    id: 3,
    name: "Apple Watch Series 9 GPS 41mm",
    price: 399,
    rating: 4.7,
    reviews: 210,
    img: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=220&q=80",
  },
  {
    id: 4,
    name: "Apple AirPods Pro (2nd Generation)",
    price: 249,
    rating: 4.8,
    reviews: 380,
    img: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=220&q=80",
  },
  {
    id: 5,
    name: "Sony Alpha a7 IV Mirrorless Camera",
    price: 1899,
    rating: 4.6,
    reviews: 98,
    img: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=220&q=80",
  },
  {
    id: 6,
    name: "Apple MacBook Air M2 13-inch 256GB",
    price: 1099,
    rating: 4.8,
    reviews: 160,
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=220&q=80",
  },
  {
    id: 7,
    name: "JBL Charge 5 Portable Bluetooth Speaker",
    price: 179,
    rating: 4.6,
    reviews: 310,
    img: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=220&q=80",
  },
  {
    id: 8,
    name: "Samsung Galaxy S23 Ultra 256GB",
    price: 1199,
    rating: 4.7,
    reviews: 220,
    img: "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=220&q=80",
  },
];

// ── Stars ──────────────────────────────────────────────────
function Stars({ rating, count }) {
  return (
    <div className="cat__card-rating">
      <div className="stars">
        {[1, 2, 3, 4, 5].map((n) => (
          <I.Star key={n} filled={n <= Math.round(rating)} />
        ))}
      </div>
      <span>({count})</span>
    </div>
  );
}

// ── Product Card ───────────────────────────────────────────
function ProductCard({ product }) {
  const [liked, setLiked] = useState(false);
  const dispatch = useDispatch();

  const handleAddToCart = async () => {
    // 1. Update Redux immediately so UI feels instant
    dispatch(
      addToCartList({
        id: product.id,
        name: product.name,
        subtitle: product.brand,
        price: product.price,
        img: product.img,
        inStock: product.inStock,
      }),
    );

    // 2. Sync with backend in the background
    try {
      await addToCart({
        product_id: product.id,
        quantity: 1,
      });
    } catch (err) {
      console.error("Cart sync failed:", err.message);
      // Optional: show a toast error here
    }
  };

  return (
    <div className="cat__card">
      <div className="cat__card-img">
        <button
          className={`cat__card-fav${liked ? " liked" : ""}`}
          onClick={() => setLiked((v) => !v)}
        >
          <I.Heart filled={liked} />
        </button>
        <img src={product.img} alt={product.name} loading="lazy" />
      </div>
      <div className="cat__card-body">
        <div className="cat__card-name">{product.name}</div>
        <Stars rating={product.rating} count={product.reviews} />
        <div className="cat__card-price">
          ${Number(product.price).toLocaleString()}.00
        </div>
        <button className="cat__add-cart" onClick={handleAddToCart}>
          <I.ShopCart /> Add to Cart
        </button>
      </div>
    </div>
  );
}

// ── Filter Group ───────────────────────────────────────────
function FilterGroup({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="cat__filter-group">
      <div
        className={`cat__filter-group-header${open ? " open" : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        <span>{title}</span>
        {open ? <I.ChevUp /> : <I.ChevDown />}
      </div>
      {open && children}
    </div>
  );
}

const Ic = ({ d, children, size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {d ? <path d={d} /> : children}
  </svg>
);

const isSameId = (firstId, secondId) =>
  firstId != null && secondId != null && String(firstId) === String(secondId);

const getCategoryId = (category) =>
  category?.category_id ?? category?.id ?? category?._id;

const getCategoryName = (category) =>
  category?.category_name ?? category?.name ?? "Category";

const getCategoryImage = (category, fallback) =>
  category?.image_url ??
  category?.image ??
  category?.thumbnail ??
  category?.category_image ??
  fallback;

const getSubCategoryId = (subCategory) =>
  subCategory?.sub_category_id ??
  subCategory?.subcategory_id ??
  subCategory?.id;

const getSubCategoryName = (subCategory) =>
  subCategory?.sub_category_name ??
  subCategory?.subcategory_name ??
  subCategory?.name ??
  "Sub Category";

const getSubCategoryImage = (subCategory, fallback) =>
  subCategory?.image_url ??
  subCategory?.image ??
  subCategory?.thumbnail ??
  subCategory?.sub_category_image ??
  fallback;

const getSubCategories = (category) =>
  Array.isArray(category?.sub_category)
    ? category.sub_category
    : Array.isArray(category?.sub_categories)
      ? category.sub_categories
      : [];

const getProductList = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.products)) return response.products;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.products)) return response.data.products;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  return [];
};

const getProductImage = (product, fallback) => {
  const images = product?.images || product?.product_images;
  if (Array.isArray(images) && images.length > 0) {
    const firstImage = images[0];
    return firstImage?.url || firstImage?.image_url || firstImage;
  }

  return (
    product?.img ||
    product?.image ||
    product?.image_url ||
    product?.thumbnail ||
    fallback
  );
};

const getProductCategoryId = (product) =>
  product?.category_id ??
  product?.category?.category_id ??
  product?.category?.id ??
  product?.category?._id;

const getProductSubCategoryId = (product) =>
  product?.sub_category_id ??
  product?.subcategory_id ??
  product?.subCategoryId ??
  product?.sub_category?.sub_category_id ??
  product?.sub_category?.id ??
  product?.sub_category?._id;

const getProductBrand = (product) =>
  product?.brand ??
  product?.brand_name ??
  product?.vendor?.vendor_name ??
  product?.vendor?.store_company_name ??
  product?.vendor_name;

const getProductStockStatus = (product) => {
  if (product?.in_stock != null) return Boolean(product.in_stock);
  if (product?.stock_status) return product.stock_status === "in_stock";
  const stockQuantity = product?.inventory?.quantity ?? product?.quantity;
  if (stockQuantity != null) return Number(stockQuantity) > 0;
  return true;
};

const normalizeProduct = (product, index) => ({
  id: product?.product_id ?? product?.id ?? product?._id ?? index,
  name: product?.product_name ?? product?.name ?? product?.title ?? "Product",
  price:
    product?.sale_price ??
    product?.selling_price ??
    product?.price ??
    product?.pricing?.sale_price ??
    product?.pricing?.price ??
    0,
  rating: product?.rating ?? product?.average_rating ?? 0,
  reviews: product?.reviews ?? product?.review_count ?? 0,
  categoryId: getProductCategoryId(product),
  subCategoryId: getProductSubCategoryId(product),
  brand: getProductBrand(product),
  inStock: getProductStockStatus(product),
  createdAt: product?.created_at ?? product?.createdAt ?? product?.date,
  salesCount: product?.sales_count ?? product?.sold_count ?? product?.sold ?? 0,
  discount:
    product?.discount ??
    product?.discount_percentage ??
    product?.pricing?.discount ??
    0,
  freeShipping: Boolean(product?.free_shipping ?? product?.freeShipping),
  img: getProductImage(
    product,
    FALLBACK_PRODUCTS[index % FALLBACK_PRODUCTS.length]?.img,
  ),
});

// ── Main Component ─────────────────────────────────────────
export default function CategoryPage() {
  const history = useHistory();
  const cartItems = useSelector((state) => state.CartReducer.items);
  const cartCount = cartItems.reduce((sum, item) => sum + item.qty, 0);
  const [activeTab, setActiveTab] = useState("All");
  const [view, setView] = useState("grid");
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("newest");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [avail, setAvail] = useState({ inStock: true, outStock: false });
  const [showMoreBrands, setShowMore] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [activeCatId, setActiveCatId] = useState(null);
  const [activeSubCatId, setActiveSubCatId] = useState(null);
  const [products, setProducts] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(true);

  const handleCategorySelect = (category) => {
    const nextCategoryId = getCategoryId(category);
    setActiveCatId(nextCategoryId);
    setActiveSubCatId(null);
    setSubCategories(getSubCategories(category));
    setSelectedBrands([]);
    setSearchTerm("");
    setPage(1);
  };

  const toggleBrand = (brand) =>
    setSelectedBrands((prev) =>
      prev.includes(brand)
        ? prev.filter((item) => item !== brand)
        : [...prev, brand],
    );

  const resetFilters = () => {
    const firstCategory = categories[0];
    if (firstCategory) {
      handleCategorySelect(firstCategory);
    }
    setSelectedBrands([]);
    setAvail({ inStock: true, outStock: false });
    setActiveTab("All");
    setSearchTerm("");
    setSortBy("newest");
  };

  const activeCategory =
    categories.find((category) =>
      isSameId(getCategoryId(category), activeCatId),
    ) ?? categories[0];
  const activeCategoryName = getCategoryName(activeCategory);
  const activeCategoryImage = getCategoryImage(activeCategory, SUBCATS[0]?.img);

  const categoryProducts = activeCatId
    ? products.filter((product) => isSameId(product.categoryId, activeCatId))
    : products;

  const brandOptions = Object.values(
    categoryProducts.reduce((acc, product) => {
      if (!product.brand) return acc;
      const key = product.brand;
      acc[key] = acc[key] || { label: key, count: 0 };
      acc[key].count += 1;
      return acc;
    }, {}),
  );
  const brands = brandOptions;

  const tabProducts = categoryProducts.filter((product) => {
    if (activeTab === "Best Sellers") return Number(product.salesCount) > 0;
    if (activeTab === "New Arrivals") return Boolean(product.createdAt);
    if (activeTab === "Deals") return Number(product.discount) > 0;
    if (activeTab === "Top Rated") return Number(product.rating) >= 4;
    if (activeTab === "Free Shipping") return product.freeShipping;
    return true;
  });

  const visibleProducts = tabProducts.filter((product) => {
    const matchesSubCategory =
      !activeSubCatId || isSameId(product.subCategoryId, activeSubCatId);
    const matchesBrand =
      selectedBrands.length === 0 || selectedBrands.includes(product.brand);
    const matchesAvailability =
      (avail.inStock && product.inStock) ||
      (avail.outStock && !product.inStock);
    const searchableText = [product.name, product.brand]
      .filter(Boolean)
      .join(" ");
    const matchesSearch =
      !searchTerm ||
      searchableText.toLowerCase().includes(searchTerm.trim().toLowerCase());

    return (
      matchesSubCategory && matchesBrand && matchesAvailability && matchesSearch
    );
  });

  const categoryCount = categoryProducts.length;
  const inStockCount = categoryProducts.filter(
    (product) => product.inStock,
  ).length;
  const outStockCount = Math.max(categoryProducts.length - inStockCount, 0);
  const sortedProducts = [...visibleProducts].sort((first, second) => {
    if (sortBy === "price-asc")
      return Number(first.price) - Number(second.price);
    if (sortBy === "price-desc")
      return Number(second.price) - Number(first.price);
    if (sortBy === "rating")
      return Number(second.rating) - Number(first.rating);

    return new Date(second.createdAt || 0) - new Date(first.createdAt || 0);
  });
  const visibleCount = sortedProducts.length;
  const pageSize = 8;
  const totalPages = Math.max(1, Math.ceil(visibleCount / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pages = Array.from(
    { length: totalPages },
    (_, index) => index + 1,
  ).slice(0, 5);
  const displayedProducts = sortedProducts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );
  const subCategoryCards = subCategories.map((subCategory, index) => {
    const subCategoryId = getSubCategoryId(subCategory);
    return {
      id: subCategoryId,
      label: getSubCategoryName(subCategory),
      items: categoryProducts.filter((product) =>
        isSameId(product.subCategoryId, subCategoryId),
      ).length,
      cls: SUBCATS[index % SUBCATS.length]?.cls ?? "smartphones",
      img: getSubCategoryImage(
        subCategory,
        SUBCATS[index % SUBCATS.length]?.img,
      ),
    };
  });

  const getAllCategories = async () => {
    try {
      const response = await getAllCategory();
      const dbCategories = response?.data?.categories || [];
      if (response?.data?.status && dbCategories.length > 0) {
        const firstCategory = dbCategories[0];
        setCategories(dbCategories);
        handleCategorySelect(firstCategory);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoadingCategories(false);
    }
  };

  const getAllProducts = async () => {
    try {
      const response = await getProducts(1, 1000);
      setProducts(getProductList(response).map(normalizeProduct));
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    getAllCategories();
    getAllProducts();
  }, []);

  return (
    <div className="cat">
      {/* ── Navbar ── */}
      <nav className="cat__nav">
        <button className="cat__hamburger">
          <I.Menu />
        </button>
        <div className="cat__logo">Ome</div>
        <div className="cat__search">
          <I.Search />
          <input
            type="text"
            placeholder="Search for products, brands and more..."
          />
        </div>
        <div className="cat__nav-actions">
          <button className="cat__nav-btn">
            <I.User />
            <span>Account</span>
          </button>
          <button className="cat__nav-btn">
            <I.Heart />
            <span>Wishlist</span>
          </button>
          <button
            className="cat__nav-btn"
            onClick={() => history.push("/cart")}
          >
            <I.Cart />
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            <span>Cart</span>
          </button>
        </div>
      </nav>

      <div className="cat__layout">
        {/* ── Main ── */}
        <main className="cat__main">
          {/* Breadcrumb */}
          <nav className="cat__breadcrumb">
            <a href="#">Home</a>
            <I.ChevRight />
            <a href="#">Categories</a>
            <I.ChevRight />
            <strong>{activeCategoryName}</strong>
          </nav>

          {/* Hero */}
          <div className="cat__hero">
            <div className="cat__hero-content">
              <div className="eyebrow">{activeCategoryName}</div>
              <h1>
                Explore
                <br />
                {activeCategoryName}
              </h1>
              <p>
                Browse products and sub categories
                <br />
                matched to the latest catalog data.
              </p>
              <div className="count">{categoryCount} Products</div>
            </div>
            <div className="cat__hero-img">
              <img src={activeCategoryImage} alt={activeCategoryName} />
            </div>
          </div>

          {/* Tabs */}
          <div className="cat__tabs">
            {TABS.map((tab) => (
              <button
                key={tab}
                className={`cat__tab${activeTab === tab ? " active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setPage(1);
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Content: Filters + Products */}
          <div className="cat__content">
            {/* ── Filters ── */}
            <aside className="cat__filters">
              <div className="cat__filters-header">
                <h3>Filters</h3>
                <button>
                  <I.Sliders />
                </button>
              </div>

              {/* Categories */}
              <FilterGroup title="Categories">
                {loadingCategories && (
                  <div className="cat__empty">Loading categories...</div>
                )}
                {!loadingCategories &&
                  categories?.map((c, i) => {
                    const categoryId = getCategoryId(c);
                    const count = products.filter((product) =>
                      isSameId(product.categoryId, categoryId),
                    ).length;

                    return (
                      <div key={categoryId ?? i} className="cat__filter-check">
                        <input
                          type="checkbox"
                          id={`cat-${i}`}
                          checked={isSameId(activeCatId, categoryId)}
                          onChange={() => handleCategorySelect(c)}
                        />
                        <label htmlFor={`cat-${i}`}>
                          {getCategoryName(c)}{" "}
                          <span className="count">({count})</span>
                        </label>
                      </div>
                    );
                  })}
              </FilterGroup>

              {/* Price Range */}
              <FilterGroup title="Price Range">
                <div className="cat__price-range">
                  <div className="cat__price-track">
                    <div className="fill" style={{ left: "5%", right: "5%" }} />
                    <div className="cat__price-thumb" style={{ left: "5%" }} />
                    <div className="cat__price-thumb" style={{ left: "95%" }} />
                  </div>
                  <div className="cat__price-labels">
                    <span>$50</span>
                    <span>$1,000+</span>
                  </div>
                  <div className="cat__price-value">$50 - $1,000+</div>
                </div>
              </FilterGroup>

              {/* Brands */}
              <FilterGroup title="Brands">
                {(showMoreBrands ? brands : brands.slice(0, 4)).map((b, i) => (
                  <div key={b.label} className="cat__filter-check">
                    <input
                      type="checkbox"
                      id={`brand-${i}`}
                      checked={selectedBrands.includes(b.label)}
                      onChange={() => toggleBrand(b.label)}
                    />
                    <label htmlFor={`brand-${i}`}>
                      {b.label} <span className="count">({b.count})</span>
                    </label>
                  </div>
                ))}
                {brands.length === 0 && (
                  <div className="cat__empty">No brands found.</div>
                )}
                {brands.length > 4 && (
                  <button
                    className="cat__show-more"
                    onClick={() => setShowMore((v) => !v)}
                  >
                    {showMoreBrands ? "Show Less" : "Show More"} <I.ChevDown />
                  </button>
                )}
              </FilterGroup>

              {/* Rating */}
              <FilterGroup title="Rating">
                {RATINGS.map(({ stars, count }) => (
                  <div key={stars} className="cat__rating-row">
                    <input type="checkbox" id={`rating-${stars}`} />
                    <div className="stars">
                      {[1, 2, 3, 4, 5].map((n) => (
                        <I.Star key={n} filled={n <= stars} />
                      ))}
                    </div>
                    <span className="count">({count})</span>
                  </div>
                ))}
              </FilterGroup>

              {/* Availability */}
              <FilterGroup title="Availability">
                <div className="cat__filter-check">
                  <input
                    type="checkbox"
                    id="in-stock"
                    checked={avail.inStock}
                    onChange={() =>
                      setAvail((v) => ({ ...v, inStock: !v.inStock }))
                    }
                  />
                  <label htmlFor="in-stock">
                    In Stock <span className="count">({inStockCount})</span>
                  </label>
                </div>
                <div className="cat__filter-check">
                  <input
                    type="checkbox"
                    id="out-stock"
                    checked={avail.outStock}
                    onChange={() =>
                      setAvail((v) => ({ ...v, outStock: !v.outStock }))
                    }
                  />
                  <label htmlFor="out-stock">
                    Out of Stock{" "}
                    <span className="count">({outStockCount})</span>
                  </label>
                </div>
              </FilterGroup>

              {/* Actions */}
              <div className="cat__filter-actions">
                <button className="cat__apply-btn">Apply Filters</button>
                <button className="cat__reset-btn" onClick={resetFilters}>
                  Reset All
                </button>
              </div>
            </aside>

            {/* ── Products ── */}
            <div className="cat__products-col">
              {/* Header row */}
              <div className="cat__products-header">
                <h2>
                  {activeSubCatId
                    ? getSubCategoryName(
                        subCategories.find((subCategory) =>
                          isSameId(
                            getSubCategoryId(subCategory),
                            activeSubCatId,
                          ),
                        ),
                      )
                    : activeCategoryName}{" "}
                  <span>({visibleCount} Products)</span>
                </h2>
                <div className="cat__prod-search">
                  <I.Search />
                  <input
                    type="text"
                    placeholder="Search products..."
                    value={searchTerm}
                    onChange={(event) => {
                      setSearchTerm(event.target.value);
                      setPage(1);
                    }}
                  />
                </div>
                <div className="cat__sort">
                  <select
                    value={sortBy}
                    onChange={(event) => {
                      setSortBy(event.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="newest">Newest First</option>
                    <option value="price-asc">Price: Low to High</option>
                    <option value="price-desc">Price: High to Low</option>
                    <option value="rating">Top Rated</option>
                  </select>
                </div>
                <div className="cat__view-toggle">
                  <button
                    className={view === "grid" ? "active" : ""}
                    onClick={() => setView("grid")}
                  >
                    <I.Grid />
                  </button>
                  <button
                    className={view === "list" ? "active" : ""}
                    onClick={() => setView("list")}
                  >
                    <I.List />
                  </button>
                </div>
              </div>

              {/* Sub-category cards */}
              <div className="cat__subcats">
                {subCategoryCards.map(({ id, label, items, cls, img }) => (
                  <div
                    key={id ?? label}
                    className={`cat__subcat-card cat__subcat-card--${cls}${isSameId(activeSubCatId, id) ? " active" : ""}`}
                    onClick={() => {
                      setActiveSubCatId((current) =>
                        isSameId(current, id) ? null : id,
                      );
                      setPage(1);
                    }}
                  >
                    <div className="sc-info">
                      <h4>{label}</h4>
                      <div className="items">{items} Items</div>
                      <a href="#">
                        Shop Now <I.ChevRight />
                      </a>
                    </div>
                    <img
                      className="sc-img"
                      src={img}
                      alt={label}
                      loading="lazy"
                    />
                  </div>
                ))}
                {!loadingCategories && subCategoryCards.length === 0 && (
                  <div className="cat__empty">No sub categories found.</div>
                )}
              </div>

              {/* Product Grid */}
              <div className="cat__grid">
                {loadingProducts && (
                  <div className="cat__empty">Loading products...</div>
                )}
                {!loadingProducts &&
                  displayedProducts.map((p) => (
                    <ProductCard key={p.id} product={p} />
                  ))}
                {!loadingProducts && visibleProducts.length === 0 && (
                  <div className="cat__empty">
                    No products found for this selection.
                  </div>
                )}
              </div>

              {/* Promo Banner */}
              <div className="cat__promo-banner">
                <div className="cat__promo-content">
                  <div className="sale-tag">Summer Sale</div>
                  <h2>
                    Up to 50% Off
                    <br />
                    On Selected Products
                  </h2>
                  <button>Shop Deals</button>
                </div>
                <div className="cat__promo-badge">
                  <span className="up">UP TO</span>
                  <span className="pct">50%</span>
                  <span className="off">OFF</span>
                </div>
                <div className="cat__promo-img">
                  <img
                    src="https://images.unsplash.com/photo-1484704849700-f032a568e944?w=360&q=80"
                    alt="Sale"
                  />
                </div>
              </div>

              {/* Pagination */}
              <div className="cat__pagination">
                <button
                  className="cat__page-btn"
                  disabled={currentPage === 1}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                >
                  <I.ChevLeft /> Previous
                </button>

                {pages.map((n) => (
                  <button
                    key={n}
                    className={`cat__page-btn${currentPage === n ? " active" : ""}`}
                    onClick={() => setPage(n)}
                  >
                    {n}
                  </button>
                ))}

                {totalPages > 5 && (
                  <button className="cat__page-btn cat__page-btn--ellipsis">
                    ...
                  </button>
                )}

                {totalPages > 5 && (
                  <button
                    className={`cat__page-btn${page === totalPages ? " active" : ""}`}
                    onClick={() => setPage(totalPages)}
                  >
                    {totalPages}
                  </button>
                )}

                <button
                  className="cat__page-btn"
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                >
                  Next <I.ChevRight />
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Trust Bar */}
      <div className="cat__trust">
        {[
          {
            icon: <I.Truck />,
            title: "Free Shipping",
            sub: "On orders over $50",
          },
          {
            icon: <I.Refresh />,
            title: "30-Day Returns",
            sub: "No questions asked",
          },
          {
            icon: <I.Shield />,
            title: "Secure Payment",
            sub: "100% protected",
          },
          {
            icon: <I.Headphones />,
            title: "24/7 Support",
            sub: "We're here to help",
          },
        ].map(({ icon, title, sub }) => (
          <div key={title} className="cat__trust-item">
            {icon}
            <div>
              <strong>{title}</strong>
              <span>{sub}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
